import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2Cliente } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import * as SocioCrud from 'services/socio.service'

const ClienteFormGroup = ({ clienteSeleccionado, setClienteSeleccionado }) => {
  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      setClienteSeleccionado({ ...data, _id: pickedMember.value })
    })
  }

  const clickClear = () => {
    setClienteSeleccionado(null)
  }

  return (
    <>
      <Form.Group>
        <Form.Label text='CLIENTE' htmlFor='input-codigoRucSocio' md={3} />
        <Col md={6}>
          {clienteSeleccionado ? (
            <ClearInputGroup
              id='input-codigoRucSocio'
              iValue={`${clienteSeleccionado.numeroDocumento} - ${clienteSeleccionado.razonSocial}`}
              clickClear={clickClear}
            />
          ) : (
            <Select2Cliente id='codigoRucSelect' onChange={onChangeSocioHandler} />
          )}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(ClienteFormGroup)
